import type { PlatformData } from '../core/types/PlatformData';

import { getVanillaArticleType } from './modules/getVanillaArticleType';
import { hawk } from './modules/hawk';
import { addDynamicWidgets } from './utils/addDynamicWidgets';
import { getArticleId } from './utils/getArticleId';
import { getKeywords } from './utils/getKeywords';
import { getVanillaTerritory } from './utils/getTerritory';

const getPlatformData = async (): Promise<PlatformData> => {
  const keywords = await getKeywords();
  const articleType = getVanillaArticleType({
    keywords,
    // Allow overriding the URL path for Cypress tests
    urlPath: new URL(window.hawk_force_url ?? window.location.href).pathname,
  });

  return {
    articleType,
    territory: getVanillaTerritory(),
    keywords,
    articleId: getArticleId(),
  };
};

hawk({ getPlatformData, addDynamicWidgets });
